import { LeanBrandTileRendererBase } from "@faire/deprecated-retailer-visitor-shared/components/LeanBrandTileRenderer/__internal__/LeanBrandTileRendererBase";
import * as React from "react";

import { BrandTileProps } from "./__internal__/BrandTileProps";

export const LeanBrandTileRenderer: React.FC<BrandTileProps> = (props) => (
  <LeanBrandTileRendererBase {...props} />
);
